import { SessionAvailibilitySlot } from 'redux/actions/mentorship-program-connections';
import { MentoringProgramEnrollment } from './mentoring-program-enrollments';

export enum MentorshipProgramConnectionType {
  MANUAL = 'manual',
  AUTO_GENERATED = 'auto',
}

export type MentorshipProgramConnectionMember = {
  id: number;
  mentorshipProgramEnrollment: Pick<MentoringProgramEnrollment, 'id' | 'user' | 'role' >;
};

export type SessionAvailabilityByDay = {
  [day: string]: {
    slots: SessionAvailibilitySlot[];
    loading?: boolean;
  }
};

type SessionAvailabilitySlots = {
  [programId: number]: {
    [duration: number]: SessionAvailabilityByDay[];
  }
};

export type MentorshipProgramConnection = {
  id: number;
  mentorshipProgramId: number;
  formationType: MentorshipProgramConnectionType;
  mentorshipProgramConnectionMembers: MentorshipProgramConnectionMember[];
  createdAt?: Date;
  sessionAvailabilitySlots?: SessionAvailabilitySlots;
};
